import { useState } from 'react'
import Galery from '../../components/Galery/Galery'
import SelectMenu from '../../components/SelectMenu/SelectMenu'
import './Home.scss'
import { useContext } from 'react'
import { ThemeContext } from '../../context'


export default function Home()
{
    const {theme} = useContext(ThemeContext)


    //periode
    const [periodSelected, setPeriodSelected] = useState("")
    //gestion des pays
    const [paysOrigine, setPaysOrigine] = useState("")
    //gestion formation
    const [formationSelected, setFormationSelected] = useState("")
    //gestion organisme
    const [organismeSelected, setOrganismeSelected] = useState("")
    return(
        <main id={`home_${theme}`}>
            <SelectMenu 
                periodSelected={periodSelected} setPeriodSelected={setPeriodSelected}
                paysOrigine={paysOrigine} setPaysOrigine={setPaysOrigine}
                formationSelected={formationSelected} setFormationSelected={setFormationSelected}
                organismeSelected={organismeSelected} setOrganismeSelected={setOrganismeSelected}
            />
            <Galery
                periodSelected={periodSelected}
                paysOrigine={paysOrigine}
                formationSelected={formationSelected}
                organismeSelected={organismeSelected}
            />
        </main>
    )
}